import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import '../public/assets/css/style.css'

// createApp(App).use(router).mount('#app')
const app = createApp(App)

// app.config.globalProperties.$apiURL = `https://103.27.206.184:1443/api`
app.config.globalProperties.$apiURL = 'https://jikuops.com:1443/api'

app.use(router)
app.mount('#app')

